import { CUSTOMER_AGENT, DATA_AGENT } from '../shared/constants';
export const PROSPECTING_AGENT = {
  id: 'Prospecting Agent Contact Monitoring',
  labelKey: 'advancedCreditEstimator.agents.prospectingAgent.name',
  badgeKey: 'advancedCreditEstimator.agents.prospectingAgent.badge',
  currentPlanBadgeKey: 'advancedCreditEstimator.agents.prospectingAgent.currentPlanBadge',
  minTier: 'starter',
  featureType: 'PROSPECTING_AGENT'
};
export const AI_WORKFLOW_ACTIONS = {
  id: 'Ai Workflow Actions',
  labelKey: 'advancedCreditEstimator.automationTools.workflows.name',
  badgeKey: 'advancedCreditEstimator.automationTools.workflows.badge',
  currentPlanBadgeKey: 'advancedCreditEstimator.automationTools.workflows.currentPlanBadge',
  minTier: 'professional',
  featureType: 'WORKFLOWS'
};
export const INTENT_MONITORING = {
  id: 'Intent Monitoring',
  labelKey: 'advancedCreditEstimator.automationTools.buyerIntent.name',
  badgeKey: 'advancedCreditEstimator.automationTools.buyerIntent.badge',
  currentPlanBadgeKey: 'advancedCreditEstimator.automationTools.buyerIntent.currentPlanBadge',
  minTier: 'starter',
  featureType: 'INTENT'
};
export const DATA_STUDIO_SYNC = {
  id: 'Data Studio Sync',
  labelKey: 'advancedCreditEstimator.automationTools.dataSync.name',
  badgeKey: 'advancedCreditEstimator.automationTools.dataSync.badge',
  currentPlanBadgeKey: 'advancedCreditEstimator.automationTools.dataSync.currentPlanBadge',
  minTier: 'professional',
  featureType: 'DATA_STUDIO_SYNC'
};
export const ADVANCED_AGENTS = [CUSTOMER_AGENT, PROSPECTING_AGENT, DATA_AGENT];
export const AUTOMATION_TOOLS = [AI_WORKFLOW_ACTIONS, INTENT_MONITORING, DATA_STUDIO_SYNC];
export const ALL_ADVANCED_TOOLS = [...ADVANCED_AGENTS, ...AUTOMATION_TOOLS];